import { render } from "./Form.vue?vue&type=template&id=8d525db8"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=8d525db8&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__